import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import FormatUnderlined from "@mui/icons-material/FormatUnderlined";
import { IconButton, Tooltip } from "@mui/material";
import { FORMAT_TEXT_COMMAND } from "lexical";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { floatingToolbarStyles } from "./floating-toolbar-styles";
import type { ToolbarProps } from "./props";

export const UnderlineButton: FC<ToolbarProps & { active: boolean }> = ({
  disabled,
  active,
  mode,
}) => {
  const { t } = useTranslation();
  const [editor] = useLexicalComposerContext();

  return (
    <Tooltip title={t("Underline")}>
      <IconButton
        data-analytics-id={`lexical-${mode}-underline`}
        disabled={disabled}
        data-testid={`${mode}-button-underline`}
        data-active={active}
        aria-pressed={active}
        aria-label="Underline"
        tabIndex={-1}
        sx={{
          ...floatingToolbarStyles[mode].button,
          backgroundColor: active ? "background.active" : "background.neutral",
        }}
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, "underline");
        }}
      >
        <FormatUnderlined sx={floatingToolbarStyles[mode].formatIcon} />
      </IconButton>
    </Tooltip>
  );
};
